import React, { useState, useEffect } from "react";
import AssignedUsersTable from "./AssignedUsersTable";
import { ASSIGNED_USERS_OF_SINGLE_CLIENT_HEADERS } from "../../../../constant/tableHeadersConstants/clientDirectoryConstant/assignedUsersOfSingleClientTableHeaders";
import { GetAllAssignUserOfSingleClient } from "../../../../redux/auth/authTypes";
import {
  CommonHeader,
  ConfirmationModal,
  EmptyListPage,
  TableLoader,
} from "../../../commons";
import { SearchIcon } from "../../../Icon";
import AssignedUserListFilter from "./AssignedUserListFilter";
import useDebounce from "../../../../customHooks/useDebounce";
import { EmptyAssignedUser } from "../../../../assets/images";
import toast from "react-hot-toast";

type AppProps = {
  allAssignUserOfSingleClient:
    | GetAllAssignUserOfSingleClient
    | null
    | undefined;
  handleAssignedUsersFilter: (data: any) => void;
  userFetching: boolean | undefined;
  handleUnassignUser?: (data: any) => void;
  authSuccess?: number | null;
};
const AssignedUsers = ({
  userFetching,
  allAssignUserOfSingleClient,
  handleAssignedUsersFilter,
  handleUnassignUser,
  authSuccess,
}: AppProps) => {
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState("");
  const [userType, setUserType] = useState("");
  const [assignedUsers, setAssignedUsers] = useState<number[]>([]);
  const [showUnassignConfirmModal, setShowUnassignConfirmModal] =
    useState(false);
  const [multiSelectData, setMultiSelectData] = useState<any>({
    userType: "",
  });
  useEffect(() => {
    if (userType === "") {
      const finalData = {
        userType,
        searchValue,
      };
      handleAssignedUsersFilter?.(finalData);
    }
  }, [userType]);

  useEffect(() => {
    if (userType) {
      setClearFilter(true);
    } else {
      setClearFilter(false);
    }
  }, [allAssignUserOfSingleClient]);

  useEffect(() => {
    if (authSuccess === 1) {
      toast.success("Users Unassigned Successfully!", {
        duration: 2000,
      });
      const finalData = {
        userType,
        searchValue,
      };
      handleAssignedUsersFilter?.(finalData);
      setAssignedUsers([]);
    }
  }, [authSuccess]);

  const handleSubmit = () => {
    setMultiSelectData(userType);
    const finalData = {
      userType,
      searchValue,
    };
    handleAssignedUsersFilter?.(finalData);
  };

  const fetchNewData = () => {
    if (searchValue) {
      const finalData = {
        userType,
        searchValue,
      };
      handleAssignedUsersFilter?.(finalData);
    }
  };

  useDebounce(
    () => {
      if (searchValue) {
        fetchNewData();
      }
    },
    500,
    [searchValue]
  );

  const handleSearch = (data: any) => {
    setSearchValue(data.target.value);
    if (data.target.value.length === 0) {
      const finalData = {
        userType,
        searchValue,
      };
      handleAssignedUsersFilter?.(finalData);
    }
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "white",
          paddingTop: "23px",
          border: "1px solid #bfcbe1",
          borderRadius: "0px 0px 6px 6px",
        }}
      >
        <div className="row">
          <div className="col-md-12 d-flex justify-content-between">
            <div className="col-md-4 ml-3" style={{ padding: 0 }}>
              <div
                className="d-flex flex-column"
                style={{ justifyContent: "center", alignItems: "flex-start" }}
              >
                <h6 style={{ fontSize: "18px", fontWeight: 500 }}>
                  Assigned Users List
                </h6>
                <div
                  style={{
                    color: "rgb(124, 141, 176)",
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                >
                  Total{" "}
                  {allAssignUserOfSingleClient?.total_count
                    ? allAssignUserOfSingleClient?.total_count
                    : 0}{" "}
                  entries found
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end col-md-8">
              <div>
                <button
                  className="btn btn-outline"
                  disabled={assignedUsers?.length === 0}
                  onClick={() => {
                    setShowUnassignConfirmModal(!showUnassignConfirmModal);
                    // handleConfirmUnassigne();
                  }}
                >
                  Unassign User's
                </button>
              </div>
              <div className="col-md-4">
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={handleSearch}
                  style={{ paddingLeft: "35px" }}
                  value={searchValue}
                />
              </div>
              <div className="mr-3">
                <AssignedUserListFilter
                  setUserType={setUserType}
                  userType={userType}
                  clearFilter={clearFilter}
                  handleSubmit={handleSubmit}
                  multiSelectData={multiSelectData}
                />
              </div>
            </div>
          </div>
        </div>
        {userFetching ? (
          <TableLoader Rows={7} ColumnPerRow={3} />
        ) : (
          <>
            {allAssignUserOfSingleClient?.total_count !== 0 ? (
              <AssignedUsersTable
                tableHeader={ASSIGNED_USERS_OF_SINGLE_CLIENT_HEADERS}
                allAssignUserOfSingleClient={
                  allAssignUserOfSingleClient
                    ? allAssignUserOfSingleClient
                    : null
                }
                assignedUsers={assignedUsers}
                setAssignedUsers={setAssignedUsers}
              />
            ) : (
              <div className="mt-5 p-4">
                <EmptyListPage
                  title="Empty Assigned Users List!"
                  imageWidth="25%"
                  image={EmptyAssignedUser}
                />
              </div>
            )}
          </>
        )}
      </div>
      {showUnassignConfirmModal && (
        <ConfirmationModal
          toggle={() => {
            setShowUnassignConfirmModal(!showUnassignConfirmModal);
          }}
          isOpen={showUnassignConfirmModal}
          title={"Unassign User's"}
          message={`Are you sure you want to Proceed`}
          confirmButtonText={"Confirm"}
          onPressConfirm={() => {
            handleUnassignUser && handleUnassignUser(assignedUsers);
            setShowUnassignConfirmModal(!showUnassignConfirmModal);
          }}
        />
      )}
    </>
  );
};

export default AssignedUsers;
